import Loading from "components/loading/Loading";
import PrivateLayout from "layouts/Private";
import PublicLayout from "layouts/Public";
import { Suspense, useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import adminRoutes from "routes/admin";
import clinicRoutes from "routes/clinic";
import publicRoutes from "routes/public";
import "./App.css";
import i18n from "./i18n";
import { checkMaintenance } from "helpers/maintenanceChecker";
import Maintenance from "pages/maintenance/Maintenance";

const App = () => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkMaintenance()
      .then((result) => setIsMaintenance(result))
      .finally(() => setChecking(false));
  }, []);

  if (checking) return <Loading />;
  if (isMaintenance) return (
    <I18nextProvider i18n={i18n}>
      <Maintenance />
    </I18nextProvider>
  );

  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Loading />}>
          <Router>
            <Switch>
              {publicRoutes.map((route) => (
                <Route
                  exact
                  key={route.path}
                  path={route.path}
                  render={(props) => (
                    <PublicLayout>
                      <route.component {...props} />
                    </PublicLayout>
                  )}
                />
              ))}
              <PrivateLayout>
                {clinicRoutes.map((route) => (
                  <Route
                    exact
                    key={route.path}
                    path={route.path}
                    render={(props) => <route.component {...props} />}
                  />
                ))}
                {adminRoutes
                  .filter((route) => route.component)
                  .map((route) => (
                    <Route
                      exact
                      key={route.path}
                      path={route.path}
                      render={(props) => <route.component {...props} />}
                    />
                  ))}
              </PrivateLayout>
            </Switch>
          </Router>
          <ToastContainer />
        </Suspense>
      </I18nextProvider>
    </div>
  );
};

export default App;
